var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"tests-page-content"},[_c('b-col',{attrs:{"cols":"12","md":"12","lg":"3"}},[_c('tests-nav')],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","md":"12","lg":"9"}},[_c('tests-list',{attrs:{"type":"active"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }